export default __webpack_public_path__ + "static/media/amazon-web-services.482ae98b.svg";